export default __webpack_public_path__ + "static/media/ethereum.4e0e134b.svg";